<template>
  <div class="leftBar">
    <v-drawer :direction="'left'" :width="'26%'">
      <div class="animated fadeInLeftBig dx">
        <bar-card class="lefts lefts1" :bg="'border-new'">
          <!-- <g-title>主要农产品产值</g-title> -->
          <g-title>农作物生产情况</g-title>
          <div class="panelContent">
            <left-top />
          </div>
        </bar-card>
        <bar-card class="lefts lefts2" :bg="'border-new'">
          <g-title :bg="'jjzw'">农作物生产情况</g-title>
          <div class="panelContent">
            <left-mid />
          </div>
        </bar-card>
        <bar-card class="lefts" :bg="'border-new'">
          <g-title :bg="'sg'">水果等经济作物生产情况</g-title>
          <!-- <g-title :bg="'sg'">各水果播种面积与产量</g-title> -->
          <div class="panelContent">
            <left-bot />
          </div>
        </bar-card>
      </div>
    </v-drawer>
  </div>
</template>

<script>
import gTitle from "../components/gTitle";
import leftTop from "./leftBar/leftTop";
import leftMid from "./leftBar/leftMid";
import leftBot from "./leftBar/leftBot";
export default {
  components: {
    gTitle,
    leftTop,
    leftBot,
    leftMid
  },
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
.dx
  height 100%
.panelContent
  height calc(100% - 39px)
  color #fff
.lefts
  margin-bottom 10px
  // height calc(28.33% - 10px)
  height calc(32% - 10px)
.lefts1
  // height calc(38.33% - 10px)
  height calc(36% - 10px)
.lefts2
  // height calc(33.33% - 10px)
  height calc(32% - 10px)
.leftBar
  >>>.side
    bottom 8px
@media (min-height 1400px)
  .leftBar
    >>>.side
      width 24% !important
</style>
